import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { AuthGuardSSO } from './core/auth/auth.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'public', pathMatch: 'full' },
    { path: 'public', loadChildren: () => import('./pages/public/public.module').then((m) => m.PublicModule) },
    { path: 'private', loadChildren: () => import('./pages/private/private.module').then((m) => m.PrivateModule), canActivate: [AuthGuard] },
    { path: 'admin', loadChildren: () => import('./pages/admin/admin.module').then((m) => m.AdminModule), canActivate: [AuthGuardSSO] }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
